import React from 'react';

import BlockAccessPage from '../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../components/PageContent/PageContent';
import Tabs from '../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../constants/permissionsEnum';
import TranslatedText from '../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../utils/SubscriptionHelper';

import AssetDownManagement from './assetsManagment/DownstreamAsset';
import FranchiseInfo from './franchisee/FranchiseInfo';
import ProductInfo from './productInfo/ProductInfo';
import SupplierInfo from './supplierInfo/SupplierInfo';

const ValueChainManagement: React.FC = () => {
  const orgFac = [
    {
      id: 'supplier_Info',
      name: <TranslatedText translationKey="Supplier Info" />,
      component: <SupplierInfo />,
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorSupplierInfo)
    },
    {
      id: 'franchisee_Info_externalStakeholder',
      name: <TranslatedText translationKey="Franchise" />,
      component: shouldBlockModuleAccess(accessModule.externalStakeholders) ? (
        <BlockAccessPage />
      ) : (
        <FranchiseInfo />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorFranchise)
    },
    {
      id: 'product_Info_scope3',
      name: <TranslatedText translationKey="Product / Service Info" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <ProductInfo />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorProduct)
    },
    {
      id: 'assetsDown',
      name: <TranslatedText translationKey="Assets Details" />,
      component: <AssetDownManagement />,
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorAsset)
    }
  ].filter((item) => !item.hidden);

  return (
    <PageContent fullscreen={false}>
      <Tabs array={orgFac} noPadding />
    </PageContent>
  );
};

export default ValueChainManagement;
